<template>
    <div class="left">
        <div class="left-content left-content-1">
            <div class="content-title">商河县总概况</div>
            <div class="content-c">
                <a-carousel autoplay :autoplay-speed="10000">
                    <div class="content-panel">
                        <div class="block"><div>1162</div><div><p>商河县总面积</p><p>(km²)</p></div></div>
                        <div class="block"><div>91.79</div><div><p>农林牧渔业总产值</p><p>(亿)</p></div></div>
                        <div class="block"><div>64</div><div><p>商河县总人口</p><p>(万)</p></div></div>
                        <div class="block"><div>114</div><div><p>耕地面积</p><p>(万亩)</p></div></div>
                        <div class="block"><div>1.3</div><div><p>水域面积</p><p>(万公顷)</p></div></div>
                        <div class="block"><div>321</div><div><p>生产总值</p><p>(亿元)</p></div></div>
                        <div class="block"><div>86.48</div><div><p>小麦种植面积</p><p>(万亩)</p></div></div>
                        <div class="block"><div>90.55</div><div><p>玉米种植面积</p><p>(万亩)</p></div></div>
                    </div>
                    <div class="content-panel">
                        <div class="block"><div>6000</div><div><p>棉花种植面积</p><p>(亩)</p></div></div>
                        <div class="block"><div>1.4</div><div><p>蔬菜种植面积</p><p>(万公顷)</p></div></div>
                        <div class="block"><div>4</div><div><p>大畜牧存栏</p><p>(万只)</p></div></div>
                        <div class="block"><div>22.18</div><div><p>生猪存栏</p><p>(万头)</p></div></div>
                        <div class="block"><div>12.34</div><div><p>羊存栏</p><p>(万只)</p></div></div>
                        <div class="block"><div>158.75</div><div><p>肉禽存栏</p><p>(万只)</p></div></div>
                        <div class="block"><div>196.73</div><div><p>蛋禽存栏</p><p>(万只)</p></div></div>
                    </div>
                </a-carousel>
            </div>
        </div>
        <div class="left-content left-content-2">
            <div class="content-title">智慧农业-现代产业园</div>
            <div class="content-c">
                <div class="tools">
                    <a-select v-model:value="parkSelectValue" @change="getParkDetails">
                        <template #suffixIcon><caret-down-outlined style="color: #071A37"/></template>
                        <a-select-option v-for="(item, i) in parkList" :value="item.id" :key="i">{{ item.industryName }}</a-select-option>
                    </a-select>
                </div>
                <div class="video-content">
                    <div class="title">视频监控</div>
                    <div class="video">
                        <player ref="videoPlayer" v-if="videoList.length > 0" :id="'node_leftPlayer'"></player>
                        <img v-else src="../../assets/img/greenhouse_img.png" style="width: 100%;height: 100%">
                    </div>
                    <div class="control">
                        <a-radio-group v-model:value="videoSelectValue" @change="videoChange">
                            <a-radio-button v-for="(item, i) in videoList" :key="i" :value="item">{{ i+1 }}号监控</a-radio-button>
                        </a-radio-group>
                    </div>
                    <div class="title" style="margin-top: 10px">环境监测</div>
                    <div class="content-data">
                        <div class="content-block">
                            <div class="block-left"><icon-font type="icon-wendu" /></div>
                            <div class="block-right">
                                <p>空气温度</p>
                                <p v-if="tempStatus" style="color:rgb(255 80 80);">{{ parkInfo.wd }}</p>
                                <p v-else>{{ parkInfo.wd }}</p>
                            </div>
                        </div>
                        <div class="content-block">
                            <div class="block-left"><icon-font type="icon-shidujiance_1" /></div>
                            <div class="block-right">
                                <p>相对湿度</p>
                                <p v-if="sdStatus" style="color:rgb(255 80 80);">{{ parkInfo.sd }}</p>
                                <p v-else>{{ parkInfo.sd }}</p>
                            </div>
                        </div>
                        <div class="content-block">
                            <div class="block-left"><icon-font type="icon-eryanghuatan" /></div>
                            <div class="block-right"><p>二氧化碳</p><p>{{ parkInfo.co2 }}</p></div>
                        </div>
                        <div class="content-block">
                            <div class="block-left"><icon-font type="icon-taiyangfushe" /></div>
                            <div class="block-right" v-if="parkInfo.fs"><p>太阳辐射</p><p>{{ parkInfo.fs }}</p></div>
                            <div class="block-right" v-else><p>太阳光照</p><p>{{ parkInfo.gz }}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import player from "@/components/video/player"
import { CaretDownOutlined, createFromIconfontCN } from '@ant-design/icons-vue'
import {getIndustrialParksDataApi, getTownIndustrialApi} from "../../api/visualization";
import {notification} from "ant-design-vue"
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2749559_jp0oabqx5q.js',
})
export default {
    name: "left",
    setup() {
        const cusStyle1 = 'width: 100%; height: 255px'
        const parkSelectValue = ref(undefined) // 筛选园区
        const videoSelectValue = ref('0') // 监控按钮
        const tempStatus = ref(false)
        const sdStatus = ref(false)
        const townList = {
            '5162': '殷巷镇',
            '5163': '怀仁镇',
            '5164': '龙桑寺镇',
            '5165': '郑路镇',
            '5166': '贾庄镇',
            '5167': '玉皇庙镇',
            '5168': '白桥镇',
            '5169': '孙集镇',
            '5170': '韩庙镇',
            '5171': '沙河镇',
            '5172': '张坊镇',
            '6048': '许商街道',
            '0': '-1'
        }
        const parkList = []
        const parkInfo = ref({
            sd: '',
            wd: '',
            co2: '',
            gz: '',
            fs: ''
        })
        const videoList = ref([])
        return {
            cusStyle1,
            parkSelectValue,
            videoSelectValue,
            videoList,
            townList,
            parkList,
            parkInfo,
            tempStatus,
            sdStatus
        }
    },
    mounted() {
        this.getTownIndustrial()
    },
    methods: {
        videoChange(e) {
            console.log(e.target.value)
            this.$nextTick(() => {
                this.$refs.videoPlayer.play(e.target.value)
            })
        },
        async getTownIndustrial() {
            const townName = this.townList[this.$parent.townId]
            const res = await getTownIndustrialApi(townName)
            if (res.length > 0) {
                this.parkList = res
                this.parkSelectValue = this.parkList[0].id
                await this.getParkDetails(this.parkList[0].id)
            } else {
                this.tempStatus = false
                this.sdStatus = false
                this.parkList = [{industryName: '现代产业园', id: 'temp_114515', }]
                this.parkSelectValue = this.parkList[0].id
                this.parkInfo.fs = this.random(20, 28).toFixed(1) + 'LX'
                this.parkInfo.co2 = this.random(300, 800).toFixed(1) + 'ppm'
                this.parkInfo.wd = this.random(22, 28).toFixed(1) + '℃'
                this.parkInfo.sd = this.random(50, 95).toFixed(1) + '%'
                this.parkInfo.gz = this.random(1000, 11000) + 'LX'
            }
        },
        async getParkDetails(id) {
            if (id === 'temp_114515') {
                this.tempStatus = false
                this.sdStatus = false
                this.parkInfo.fs = this.random(20, 28) + 'LX'
                this.parkInfo.co2 = this.random(300, 800) + 'ppm'
                this.parkInfo.wd = this.random(22, 28) + '℃'
                this.parkInfo.sd = this.random(50, 95) + '%'
                this.parkInfo.gz = this.random(1000, 11000) + 'LX'
            } else {
                const info = await getIndustrialParksDataApi(id)
                if (info.data !== '暂无数据') {
                    if (info.data.list.length === 0) {
                        this.tempStatus = false
                        this.sdStatus = false
                        this.parkInfo.fs = '暂无数据'
                        this.parkInfo.co2 = '暂无数据'
                        this.parkInfo.wd = '暂无数据'
                        this.parkInfo.sd = '暂无数据'
                        this.parkInfo.gz = '暂无数据'
                    } else {
                        this.tempStatus = false
                        this.sdStatus = false
                        this.parkInfo.fs = ''
                        this.parkInfo.co2 = ''
                        this.parkInfo.wd = ''
                        this.parkInfo.sd = ''
                        this.parkInfo.gz = ''
                        for (const i in info.data.list) {
                            switch (info.data.list[i].equipmentName) {
                                case '太阳辐射':
                                    this.parkInfo.fs = parseFloat(info.data.list[i].equipmentValue).toFixed(1) + info.data.list[i].equipmentUnit
                                    break
                                case '二氧化碳':
                                    this.parkInfo.co2 = parseFloat(info.data.list[i].equipmentValue).toFixed(1) + info.data.list[i].equipmentUnit
                                    break
                                case '空气温度':
                                    this.parkInfo.wd = parseFloat(info.data.list[i].equipmentValue).toFixed(1) + info.data.list[i].equipmentUnit
                                    if (parseFloat(info.data.list[i].equipmentValue) > 30 || parseFloat(info.data.list[i].equipmentValue) < 16) {
                                        this.tempStatus = true
                                    }
                                    break
                                case '相对湿度':
                                    this.parkInfo.sd = parseFloat(info.data.list[i].equipmentValue).toFixed(1) + info.data.list[i].equipmentUnit
                                    if (parseFloat(info.data.list[i].equipmentValue) > 95 || parseFloat(info.data.list[i].equipmentValue) < 50) {
                                        this.sdStatus = true
                                    }
                                    break
                                case '太阳光照':
                                    this.parkInfo.gz = parseFloat(info.data.list[i].equipmentValue).toFixed(1) + info.data.list[i].equipmentUnit
                                    break
                            }
                        }
                    }
                    if (info.data.camera) {
                        this.videoList = info.data.camera
                        if (id === '2') {
                            this.videoList = [
                                'http://hk.zlm.epplink.net/live/c6f1cbb01123_01.live.flv',
                                'http://hk.zlm.epplink.net/live/c6f1cbb01123_02.live.flv',
                                'http://hk.zlm.epplink.net/live/c6f1cbb01123_03.live.flv',
                            ]
                        }
                        this.$nextTick(() => {
                            this.videoSelectValue = this.videoList[0]
                            this.$refs.videoPlayer.play(this.videoList[0])
                        })
                    } else {
                        this.videoList = []
                        this.videoSelectValue = 'null'
                    }
                } else {
                    notification.warning({ message: info.data, description: '', duration: 2 })
                    this.parkInfo.fs = '暂无数据'
                    this.parkInfo.co2 = '暂无数据'
                    this.parkInfo.wd = '暂无数据'
                    this.parkInfo.sd = '暂无数据'
                    this.parkInfo.gz = '暂无数据'
                    this.tempStatus = false
                    this.sdStatus = false
                }
            }
        },
        random(min, max) {
            return Math.random() * (max - min) + min
        }
    },
    components: {
        CaretDownOutlined,
        player,
        IconFont
    }
}
</script>

<style scoped lang="stylus">
    .left {
        width 480px
        position absolute
        z-index 1
        left 30px
        bottom 25px
        display flex
        align-items flex-end
        flex-wrap wrap
        transition 0.3s
        .left-content {
            width 100%
            height 427px
            background-image url("../../assets/img/gis_window_bg_1.png")
            background-size 100% 100%
            .content-title {
                width 100%
                height 25px
                line-height 25px
                font-size 18px
                padding-left 60px
                margin-top 9px
                color #3EF5FC
                font-family "Source Han Sans CN"
            }
            .content-c {
                width 100%
                height calc(100% - 35px)
                position relative
                .video-content {
                    width 100%
                    height 100%
                    font-family "Source Han Sans CN"
                    padding-left 30px
                    padding-top 45px
                    .content-data {
                        width 100%
                        height 100px
                        display flex
                        align-items center
                        justify-content center
                        flex-wrap wrap
                        .content-block {
                            width 45%
                            height 75px
                            display flex
                            .block-left {
                                width 70px
                                height 75px
                                line-height 75px
                                text-align center
                                color #BEEDFF
                                font-size 45px
                            }
                            .block-right {
                                display flex
                                flex-wrap wrap
                                align-items center
                                width calc(100% - 70px)
                                height 75px
                            }
                            .block-right p {
                                width 100%
                                //text-align center
                            }
                            .block-right p:first-child {
                                color #FFFFFF
                                font-size 20px
                            }
                            .block-right p:last-child {
                                color #3EF5FC
                                font-size 25px
                            }
                        }
                    }
                    .title {
                        font-size 20px
                        color #3EF5FC
                        margin-bottom 10px
                    }
                    .video {
                        width calc(100% - 30px)
                        height 240px
                    }
                    .control {
                        margin-top 10px
                        width calc(100% - 30px)
                        /deep/ .ant-radio-group{
                            display flex
                            justify-content space-between
                        }
                        /deep/ .ant-radio-button-wrapper {
                            background #00D6E1
                            border-color #00D6E1
                            color #0A5E78
                            font-size 14px
                            box-shadow 0 3px 6px rgba(0, 214, 225, 0.48)
                            border-radius 7px
                        }
                        /deep/ .ant-radio-button-wrapper:not(:first-child)::before {
                            width 0
                        }
                        /deep/ .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
                            color #00d6e1
                            background #007492
                        }
                    }
                }
                .tools {
                    position absolute
                    right 27px
                    top 16px
                    z-index 1
                    /deep/ .ant-select-selector {
                        background #3EF5FC
                        border-radius 2px
                        color #071A37
                        border-color #3EF5FC
                    }
                    /deep/ .ant-select-selection-item {
                        color #071A37
                    }
                    /deep/ .ant-input {
                        border-color #3EF5FC
                        background #3EF5FC
                        color #071A37
                    }
                    /deep/ .ant-input::-webkit-input-placeholder {
                        color: #071A37
                    }
                    /deep/ .ant-calendar-picker-icon {
                        color: rgba(7, 26, 55, 0.5)
                    }
                }
                .content-panel {
                    width 100%
                    height 255px
                    padding 0 40px
                    overflow hidden
                    display flex
                    flex-wrap wrap
                    align-items center
                    justify-content space-between
                    .block {
                        width 92px
                        height 110px
                        background-image url("../../assets/img/left_icon_0.png")
                        background-repeat no-repeat
                        background-position-y bottom
                        background-size 100% 80%
                        color #FFF
                        text-align center
                    }
                    .block div:first-child {
                        width 100%
                        height 36px
                        line-height 36px
                        overflow hidden
                        font-family 'LiquidCrystal-Normal'
                        font-size 34px
                        position relative
                        z-index 222
                    }
                    .block div:last-child {
                        width 100%
                        overflow hidden
                        font-family 'SourceHanSansCN-Regular'
                        font-size 12px
                        margin-top 20px
                    }
                }
            }
        }
        .left-content-2 {
            height 622px !important
            background-image url("../../assets/img/gis_window_bg_1.png") !important
            margin-top 21px
            padding-top 8px
        }
        .left-content-1 {
            height 289px !important
            background-image url("../../assets/img/gis_window_bg_3.png") !important
        }
    }
    @media (min-width: 1921px) {
        .left {
            width 680px
            .left-content {
                .content-c {
                    .content-panel {
                        .block {
                            margin 0 20px
                        }
                    }
                }
                .content-title {
                    padding-left 80px
                }
            }
        }
    }
</style>
